import { Outlet } from 'react-router-dom'
import CollectionsBootstrap from 'modules/incentives/lib/CollectionsBootstrap'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { useQuery } from 'modules/core/hooks/useQuery'
import { IncentivesRootPageDocument } from 'generated/resources/graphql'

const RootPage = () => {
  const { data, loading } = useQuery(IncentivesRootPageDocument)

  if (loading) {
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  const canSeeIncentives =
    data?.incentives._policies.sidebarSeeCompensationsIncentivesSubLevelItem.can ?? false

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => canSeeIncentives}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
